module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table>\n    <tr>\n        <th>Title</th>\n        <td>\n            <input type=\'text\' id=\'title\' class=\'field\' value=\''+
((__t=(title))==null?'':__t)+
'\'>\n        </td>\n    </tr>\n    <tr>\n        <th>Tags</th>\n        <td>\n            '+
((__t=(APP.UI.chooser("tag_ids", "tags", tag_ids,"multi")))==null?'':__t)+
'\n        </td>\n    </tr>\n		<tr>\n			<th>Duration</th>\n			<td>\n				'+
((__t=(APP.UI.select_from_object("date_window", {"300":"5 Minutes","1800":"Half Hour","3600":"1 Hour","86400":"1 Day","172800":"2 Days"}, date_window, "field draw") ))==null?'':__t)+
'\n			</td>\n		</tr>\n    <tr>\n      <td colspan=2>\n          <input type=\'checkbox\' '+
((__t=(legend?"checked":""))==null?'':__t)+
' id=\'legend\' class=\'field\'>\n          Legend\n        </td>\n</tr>\n</table>\n';
}
return __p;
};
